/**
 * this needs to happen before the main import so that style loaders and webpack can
 * apply it when we import things like the fonts etc...
 *
 */
declare let __webpack_nonce__: string;
__webpack_nonce__ = window.__webpack_nonce__ || '';

require('./main');
